export default __webpack_public_path__ + "static/media/earthling_6.7301ba2c.png";